import $ from 'jquery';
import { cacheBody } from 'object-cache';
import router from 'lib/router.js';
import Callbacks from 'lib/callbacks.js';

export default class ScrollToElement {
    element = null;
    target = null;
    overmeasure = 0;
    duration = 500;

    constructor(opts = {}, events = {}) {
        this.overmeasure = opts.overmeasure || 0;
        this.duration = opts.duration || 500;

        this.events = new Callbacks(events);
    }

    init(element) {
        if (!element || !element.length) {
            throw new Error('Scroll to element not found');
        }

        this.element = element;

        const targetSelector = this.element.attr('data-target');

        if (!targetSelector) {
            throw new Error('Scroll to element no target selector');
        }

        this.target = $(targetSelector);

        if (!this.target || !this.target.length) {
            throw new Error('Scroll to target not found');
        }

        this.element.on('click', ::this._onClick);
    }

    /**
     * Получить элемент к которому скролим
     *
     * @return {jquery}
     */
    getTarget() {
        return this.target;
    }

    _onClick(e) {
        this.scroll();
        e.preventDefault();
    }

    /**
     * Установить дополнительную высоту при скроле
     *
     * @param {Number} value
     *
     * @return {ScrollToElement} self
     */
    setOvermeasure(value) {
        this.overmeasure = value;
        return this;
    }

    /**
     * Установить время анимации
     *
     * @param {Number} value
     *
     * @return {ScrollToElement} self
     */
    setDuration(value) {
        this.duration = value;
        return this;
    }

    /**
     * Скрол к определенной позиции или к положению целевого элемента
     *
     * @param {Number} _position
     *
     * @return {ScrollToElement} self
     */
    scroll(_position) {
        let position = _position;

        if (position === undefined) {
            if (!this.target || !this.target.length) {
                return this;
            }

            position = this.target.offset().top || 0;
        }

        cacheBody.$page.animate(
            {
                scrollTop: `${position + this.overmeasure}px`,
            },
            {
                duration: this.duration,
                easing: 'swing',
            }
        );

        this.events.trigger('scroll');

        return this;
    }

    /**
     * Скролить к якорю (id полученный из хеша страницы)
     *
     * @param {Boolean} removeHash удалять хеш после выполнения скрола
     *
     * @return {ScrollToElement} self
     */
    byHash(removeHash = true) {
        const hash = router.getHashName();

        if (hash) {
            const element = $(`#${hash}`);

            if (!element || !element.length) {
                return this;
            }

            this.target = element;
            this.scroll();
            if (removeHash) {
                router.removeHash();
            }
        }

        return this;
    }
}
